import React from 'react'
import { Accordion } from 'react-bootstrap'
import AccordionItem from '../command/accordionItem/accordionItem'
import { useTranslation } from 'react-i18next';

interface FaqSectionProps {
  numFaqs?: number;
}

const FaqSection: React.FC<FaqSectionProps> = ({ numFaqs }) => {
  const { t } = useTranslation();
  const faqData = [
    { eventKey: '0', title: t('faq-title.one-faq-title'), bodyText: t('faq-description.one-faq-description') },
    { eventKey: '1', title: t('faq-title.two-faq-title'), bodyText: t('faq-description.two-faq-description') },
    { eventKey: '2', title: t('faq-title.three-faq-title'), bodyText: t('faq-description.three-faq-description') },
    { eventKey: '3', title: t('faq-title.four-faq-title'), bodyText: t('faq-description.four-faq-description') },
    { eventKey: '4', title: t('faq-title.five-faq-title'), bodyText: t('faq-description.five-faq-description') },
    { eventKey: '5', title: t('faq-title.six-faq-title'), bodyText: t('faq-description.six-faq-description') },
  ];
  return (
    <Accordion defaultActiveKey="0">
      {faqData.slice(0, numFaqs).map(item => (
        <AccordionItem
          key={item.eventKey}
          eventKey={item.eventKey}
          accordionTitle={item.title}
          accordionBody={item.bodyText}
        />
      ))}
    </Accordion>
  )
}

export default FaqSection